// Generated by ReScript, PLEASE EDIT WITH CARE


var default_title = "Porter | Mini trucks & bikes for delivery | Packers & Movers | Book and transport easily!";

var default_desc = "Porter offers commercial vehicles & bike for delivery services. We offer complete logistics solutions including Packers & Movers and Outstation services. Book to enjoy superfast deliveries.";

var default_image_src = "https://d16heqpiqe8phi.cloudfront.net/open-graph/fb/home/porter_logo_new_cmp.jpeg";

var default_image_alt = "Porter | Mini trucks & bikes for delivery | Packers & Movers | Book and transport easily!";

export {
  default_title ,
  default_desc ,
  default_image_src ,
  default_image_alt ,
}
/* No side effect */
